export default __webpack_public_path__ + "static/media/port1.f5a3db39.JPG";